import { createFileRoute } from '@tanstack/react-router'
import { PaymentPage } from '@/features/account/pages/billing/payment-page'

/** C4 — Payment method + billing identity (provisional, OQ3). */
export const Route = createFileRoute('/_ws/w/$workspaceId/billing/payment')({
  component: PaymentPage,
})
